export type LearningStatus = 'Good' | 'NeedsAttention' | 'InTrouble';
export const LEARNING_STATUS_DESCRIPTIONS: Record<LearningStatus, string> = {
  Good: '最終学習日時から72時間（3日）以内',
  NeedsAttention: '最終学習日時から168時間（7日）以内に学習',
  InTrouble: '最終学習日時から168時間を超えている',
} as const;
